import { atom } from 'recoil';
import { IReport } from '../../providers/reports';

export const IsVisibleReportMenuState = atom<boolean>({
  key: 'is-visible-report-menu',
  default: false,
});

export const ReportState = atom<IReport | null>({
  key: 'report-state',
  default: null,
});
